export class PacData {
    public currentPac?: string;
    public newPac?: string;
    public pac? : string;

    public constructor() {
        this.currentPac = '';
        this.newPac = '';
        this.pac = '';
    }
}
